import JobZImage from "../../../../common/jobz-img";
import { NavLink } from "react-router-dom";
import { publicUser } from "../../../../../globals/route-names";
import { loadScript, publicUrlFor } from "../../../../../globals/constants";
import { useEffect, useState } from "react";
// import CountUp from "react-countup";
import { useTranslation } from "react-i18next";
import axiosInstance from "../../../../../axiosInstance";
import { API_URL } from "../../../../../config";
import { Helmet } from 'react-helmet-async';


const colors = [
    "#E63946", // red
    "#457B9D", // blue-gray
    "#2A9D8F", // teal
    "#F4A261", // orange
    "#264653", // deep teal
    "#8E44AD", // purple
    "#D7263D", // crimson
    "#3A86FF", // vivid blue
    "#06D6A0", // mint green
    "#FFBE0B", // yellow
    "#8338EC", // violet
    "#FF006E", // pink
    "#118AB2", // bright blue
    "#073B4C", // dark navy
    "#F77F00", // deep orange
    "#38B000", // green
    "#7209B7", // purple
    "#FF7F50", // coral
    "#008080", // classic teal
];

function getRandomColor(seed) {
    const index = seed.charCodeAt(0) % colors.length;
    return colors[index];
}

function HomePage() {
    const { t } = useTranslation();
    const [candidates, setCandidates] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [imgError, setImgError] = useState(false);

    useEffect(() => {
        loadScript("js/custom.js")
        const fetchCandidates = async () => {
            try {
                const response = await axiosInstance.get(`${API_URL}/candidate-list`); // Replace with your API endpoint
                const candidateData = response.data.data.filter(
                    (user) => user.role === "candidate"
                );
                const shuffled = candidateData.sort(() => 0.5 - Math.random());
                setCandidates(shuffled.slice(0, 8));
                setLoading(false);
            } catch (err) {
                if (err.response?.data?.message) {
                    setError(err.response.data.message);
                } else {
                    setError("Failed to load candidates. Please try again later.");
                }
                setLoading(false);
            }
        };
        fetchCandidates();
    }, []);

    return (
        <>
            <Helmet>
                <title>Home | CV Diffusion</title>
                <meta name="description" content="Welcome to the home page of MyApp." />
            </Helmet>
            {/*Banner Start*/}
            <div className="twm-home-6-banner-section">
                <div className="container">
                    <div className="row">
                        {/*Left Section*/}
                        <div className="col-xl-6 col-lg-6 col-md-12">
                            <div className="twm-bnr-left-section">
                                {/* <div className="twm-bnr-title-small">
                                    <div className="bnr-title-bedge">
                                        <i className="fa fa-check" />
                                    </div>
                                    {t("Stay connect to get upcoming job with")}
                                    <span className="site-text-primary">Jobzilla</span>
                                </div> */}
                                <div className="twm-bnr-title-large">
                                    {t("Get a job offer from a European recruiter")}
                                    {/* Obtenir une offre d’emploi d’un recruteur canadien */}
                                </div>
                                <div className="twm-bnr-discription">
                                    {t("Upload your CV and let us automatically apply on your behalf to hundreds of suitable positions.")} <br />
                                    {t("Speed ​​up your job search, no more manual applications.")}
                                    {/* Nous diffusons votre CV sur notre plateforme et nous envoyons votre CV aux recruteurs correspondants chaque jour. */}
                                </div>

                            </div>
                        </div>
                        {/*right Section*/}
                        <div className="col-xl-6 col-lg-6 col-md-12 twm-bnr-right-section">
                            <div className="twm-bnr-right-content">
                                <div className="bnr-media">
                                    <JobZImage src="images/home-6/country.png" alt="#" />
                                </div>
                                <div className="bnr-bg-circle">
                                    <span />
                                </div>
                                <div className="bnr-bg-icons">
                                    <div className="icon-plus1 bounce"><i className="fa fa-plus" /></div>
                                    <div className="icon-plus2 bounce2"><i className="fa fa-plus" /></div>
                                    <div className="icon-plus3 bounce"><i className="fa fa-plus" /></div>
                                    <div className="icon-ring1 bounce2" />
                                    <div className="icon-ring2 bounce" />
                                    <div className="icon-ring3 bounce2" />
                                    <div className="bnr-block-1 bounce">
                                        <div className="bnr-block-1-content">
                                            <div className="media"><JobZImage src="images/home-6/cv-icon.png" alt="" /></div>
                                            <h3 className="title">{t("Upload your CV")}</h3>
                                        </div>
                                    </div>
                                    <div className="bnr-block-2 bounce2">
                                        <div className="bnr-block-2-content">
                                            <div className="bnr-block-2-bag">
                                                <span><JobZImage src="images/home-6/bag.png" alt="" /></span>
                                            </div>
                                            <div className="bnr-block-2-content-top">
                                                <h3 className="title">5 k</h3>
                                                <div className="media"><JobZImage src="images/home-6/graph-icon.png" alt="" /></div>
                                            </div>
                                            <div className="bnr-block-2-content-bottom">{t("People were hired")}</div>
                                        </div>
                                    </div>
                                    <div className="bnr-block-3 bounce">
                                        <JobZImage src="images/home-6/pdf-file.png" alt="#" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
            {/*Banner End*/}
            {/* HOW IT WORK SECTION START */}
            {/* <div className="section-full p-t120 p-b90 site-bg-white twm-how-it-work-area">
                <div className="container">
                    <div className="section-head center wt-small-separator-outer">
                        <div className="wt-small-separator site-text-primary">
                            <div>{t("Work process")}</div>
                        </div>
                        <h2 className="wt-title">{t("How CV Diffusion works")}</h2>
                    </div>
                    <div className="twm-how-it-work-section">
                        <div className="row">
                            <div className="col-xl-4 col-lg-6 col-md-6">
                                <div className="twm-w-process-steps">
                                    <span className="twm-large-number">01</span>
                                    <div className="twm-w-pro-top bg-clr-sky">
                                        <div className="twm-media">
                                            <span><JobZImage src="images/work-process/icon1.png" alt="icon1" /></span>
                                        </div>
                                        <h4 className="twm-title">{t("Create an")}<br />{t("account")}</h4>
                                    </div>
                                    <p>{t("Create your profile and upload your CV")}</p>
                                </div>
                            </div>
                            <div className="col-xl-4 col-lg-6 col-md-6">
                                <div className="twm-w-process-steps">
                                    <span className="twm-large-number">02</span>
                                    <div className="twm-w-pro-top bg-clr-pink">
                                        <div className="twm-media">
                                            <span><JobZImage src="images/work-process/icon2.png" alt="icon1" /></span>
                                        </div>
                                        <h4 className="twm-title">{t("Apply")} <br />
                                            {t("for your dream job")}</h4>
                                    </div>
                                    <p>{t("Select the jobs and locations you are looking for.")}</p>
                                </div>
                            </div>
                            <div className="col-xl-4 col-lg-6 col-md-6">
                                <div className="twm-w-process-steps">
                                    <span className="twm-large-number">03</span>
                                    <div className="twm-w-pro-top bg-clr-green">
                                        <div className="twm-media">
                                            <span><JobZImage src="images/work-process/icon3.png" alt="icon1" /></span>
                                        </div>
                                        <h4 className="twm-title">{t("Download")}  <br />{t("your CV")}</h4>
                                    </div>
                                    <p>{t("CV Diffusion displays your profile on the platform and applies on your behalf.")}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}
            {/* HOW IT WORK SECTION END */}
            {/* EXPLORE NEW LIFE START */}
            <div className="section-full p-t120 p-b120 twm-explore-area bg-cover " style={{ backgroundImage: `url(${publicUrlFor("images/background/bg-1.jpg")})` }}>
                <div className="container">
                    <div className="section-content">
                        <div className="row">
                            <div className="col-lg-4 col-md-12 d-none d-md-block">
                                <div className="twm-explore-media-wrap">
                                    <div className="twm-media">
                                        <JobZImage src="images/gir-large.png" alt="" />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-8 col-md-12">
                                <div className="twm-explore-content-outer">
                                    <div className="twm-explore-content">
                                        <div className="twm-l-line-1" />
                                        <div className="twm-l-line-2" />
                                        <div className="twm-r-circle-1" />
                                        <div className="twm-r-circle-2" />
                                        {/* <div className="twm-title-small">{t("Explore a new life")}</div> */}
                                        <div className="twm-title-large">
                                            <h2>{t("Automatic application for job offers in Europe with CV diffusion")}</h2>
                                            <p>{t("Upload your CV and let CV diffusion automatically apply on your behalf to hundreds of jobs that match your needs.")}</p>
                                        </div>
                                        <div className="twm-upload-file">
                                            <NavLink to={publicUser.pages.REGISTER}>
                                                <button type="button" className="site-button">{t("Submit Your Application")}<i className="feather-upload" /></button>
                                            </NavLink>
                                        </div>
                                    </div>
                                    <div className="twm-bold-circle-right" />
                                    <div className="twm-bold-circle-left" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* EXPLORE NEW LIFE END */}
            {/* CANDIDATES START */}
            <div className="section-full p-t120 p-b90 site-bg-white twm-candidate-h-page7-wrap pos-relative ">
                <div className="container">
                    {/* title="" START*/}
                    <div className="section-head center wt-small-separator-outer">
                        {/* <div className="wt-small-separator site-text-primary">
                            <div>Candidates</div>
                        </div> */}
                        <h2 className="wt-title">{t("Candidate profiles")}</h2>
                    </div>
                    {/* title="" END*/}
                </div>
                <div className="container-fluid">
                    <div className="section-content">
                        <div className="twm-candidate-h-page7">
                            {loading ? (
                                <div className="text-center">Loading candidates...</div>
                            ) : error ? (
                                <div className="text-danger text-center">{error}</div>
                            ) : candidates.length === 0 ? (
                                <div className="text-center">No candidates found.</div>
                            ) : (
                                <div className="row d-flex justify-content-center m-b30">
                                    {candidates.map((candidate) => (
                                        <div
                                            key={candidate.id}
                                            className="col-xl-3 col-lg-4 col-md-6 col-sm-6"
                                        >
                                            <div className="twm-candidates-grid-h-page7 m-b30">
                                                <div className="twm-top-section-content">
                                                    <div className="twm-media">
                                                        <div className="twm-media-pic">
                                                            {/* {candidate?.photo_url && !imgError ? (
                                                                    <img
                                                                        src={candidate.photo_url}
                                                                        alt="Profile"
                                                                        className="w-[80px] h-[80px] rounded-full object-cover"
                                                                        onError={() => setImgError(true)}
                                                                    />
                                                                ) : (  */}
                                                            <span>
                                                                <div
                                                                    className="w-[80px] h-[80px] rounded-full object-cover name-plate"
                                                                    style={{
                                                                        minWidth: "50px",
                                                                        backgroundColor: getRandomColor(candidate?.first_name?.[0]?.toUpperCase() || "A"),
                                                                        fontSize: "45px",
                                                                        fontWeight: "600",
                                                                        color: "#fff",
                                                                    }}
                                                                >
                                                                    {candidate?.first_name
                                                                        ? `${candidate.first_name[0]}`.toUpperCase()
                                                                        : candidate?.first_name?.[0]?.toUpperCase() || "?"}
                                                                </div>
                                                            </span>
                                                            {/* )} */}
                                                        </div>
                                                    </div>
                                                    <div className="twm-mid-content">
                                                        <div className="twm-candidates-tag">
                                                            <span>{t("Featured")}</span>
                                                        </div>
                                                        <h4>{`${candidate.first_name}`}</h4>
                                                        <p>{candidate.designation || "Worker"}</p>
                                                    </div>
                                                </div>
                                                <div className="twm-fot-content">
                                                    <div className="twm-left-info">
                                                        <p className="twm-candidate-address">
                                                            <i className="feather-map-pin" />
                                                            {candidate.country || t("Not specified")}
                                                        </p>
                                                        <NavLink to={publicUser.candidate.GRID.replace(":id", candidate.id)}>
                                                            <p className="twm-candidate-address">
                                                                <i className="feather-eye" />
                                                                {t("View")}
                                                            </p>
                                                        </NavLink>
                                                        <div className="twm-jobs-vacancies">
                                                            {candidate.salary || ""}
                                                            <span>{candidate.salary ? "/ Day" : ""}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                            <div className="text-center m-b30">
                                <NavLink to={publicUser.candidate.LIST} className="site-button">
                                    {t("All Candidates")}
                                </NavLink>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
            {/* CANDIDATES END */}

            {/* TESTIMONIAL SECTION START */}
            <div className="section-full p-t120 p-b90 site-bg-white twm-testimonial-v-area">
                <div className="container">
                    <div className="section-content">
                        <div className="twm-testimonial-v-section">
                            <div className="row">
                                <div className="col-xl-5 col-lg-12 col-md-12">
                                    <div className="twm-explore-content-outer2">
                                        <div className="twm-explore-top-section">
                                            {/* title="" START*/}
                                            <div className="section-head left wt-small-separator-outer">
                                                <div className="wt-small-separator site-text-primary">
                                                    <div>{t("Customer Testimonials")} </div>
                                                </div>
                                                <h2>{t("What our customers say about us")}</h2>
                                                {/* <p>You need to create an account to find the best and preferred job. lorem
                                                    Ipsum is simply dummy text of the printing and typesetting the standard dummy text ever since the  when an printer took.</p> */}
                                            </div>
                                            {/* title="" END*/}
                                            {/* <div className="twm-read-more">
                                                <NavLink to={publicUser.pages.ABOUT} className="site-button">{t("Show All Quotes")}</NavLink>
                                            </div> */}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-7 col-lg-12 col-md-12">
                                    <div className="v-testimonial-wrap">
                                        <div className="v-testi-dotted-pic">
                                            <JobZImage src="images/home-6/testimonial/dotted-block.png" alt="#" />
                                        </div>
                                        {/* Swiper */}
                                        <div className="swiper-container v-testimonial-slider">
                                            <div className="swiper-wrapper">
                                                {/*block 2*/}
                                                <div className="swiper-slide">
                                                    <div className="testimonials-v">
                                                        <div className="twm-testi-media">
                                                            <JobZImage src="images/home-6/testimonial/pic2.jpg" alt="#" />
                                                        </div>
                                                        <div className="testimonial-v-content">
                                                            <div className="t-testimonial-top">
                                                                <div className="t-quote"><i className="fa fa-quote-left" /></div>
                                                                <div className="t-rating">
                                                                    <span><i className="fa fa-star" /></span>
                                                                    <span><i className="fa fa-star" /></span>
                                                                    <span><i className="fa fa-star" /></span>
                                                                    <span><i className="fa fa-star" /></span>
                                                                    <span><i className="fa fa-star" /></span>
                                                                </div>
                                                            </div>
                                                            <div className="t-discription">Meilleure plateforme qui met en relation les candidats internationaux et les recruteurs European.
                                                                Je recommande vivement ce site à toute personne à la recherche d’un emploi au Europe.
                                                            </div>
                                                            <div className="twm-testi-detail">
                                                                <div className="twm-testi-name">Mark</div>
                                                                <div className="twm-testi-position">Chauffeur poid lourd</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {/*block 3*/}
                                                <div className="swiper-slide">
                                                    <div className="testimonials-v">
                                                        <div className="twm-testi-media">
                                                            <JobZImage src="images/home-6/testimonial/pic1.jpg" alt="#" />
                                                        </div>
                                                        <div className="testimonial-v-content">
                                                            <div className="t-testimonial-top">
                                                                <div className="t-quote"><i className="fa fa-quote-left" /></div>
                                                                <div className="t-rating">
                                                                    <span><i className="fa fa-star" /></span>
                                                                    <span><i className="fa fa-star" /></span>
                                                                    <span><i className="fa fa-star" /></span>
                                                                    <span><i className="fa fa-star" /></span>
                                                                    <span><i className="fa fa-star" /></span>
                                                                </div>
                                                            </div>
                                                            <div className="t-discription">CV Diffusion est un outil de distribution de CV qui permet aux candidats à la recherche
                                                                d’emploi au Europe d'être visible auprès des recruteurs.
                                                            </div>
                                                            <div className="twm-testi-detail">
                                                                <div className="twm-testi-name">Chantal</div>
                                                                <div className="twm-testi-position">Préposé aux bénéficiaires</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {/*block 4*/}
                                                <div className="swiper-slide">
                                                    <div className="testimonials-v">
                                                        <div className="twm-testi-media">
                                                            <JobZImage src="images/home-6/testimonial/pic4.jpg" alt="#" />
                                                        </div>
                                                        <div className="testimonial-v-content">
                                                            <div className="t-testimonial-top">
                                                                <div className="t-quote"><i className="fa fa-quote-left" /></div>
                                                                <div className="t-rating">
                                                                    <span><i className="fa fa-star" /></span>
                                                                    <span><i className="fa fa-star" /></span>
                                                                    <span><i className="fa fa-star" /></span>
                                                                    <span><i className="fa fa-star" /></span>
                                                                    <span><i className="fa fa-star" /></span>
                                                                </div>
                                                            </div>
                                                            <div className="t-discription">Grâce à la plateforme CV Diffusion j’ai été contacté par plusieurs
                                                                employeurs  European intéressés par mon profil.
                                                            </div>
                                                            <div className="twm-testi-detail">
                                                                <div className="twm-testi-name">Brahim</div>
                                                                <div className="twm-testi-position">Soudeur</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* Add Pagination */}
                                            <div className="swiper-pagination" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* TESTIMONIAL SECTION END */}

            {/* SUBSCRIBE SECTION START */}
            <div className="section-full twm-hpage-6-subs-wrap bg-cover " style={{ backgroundImage: `url(${publicUrlFor("images/home-6/subscribe-bg.jpg")})` }}>
                <div className="container">
                    <div className="section-content">
                        <div className="row">
                            {/* <div className="col-lg-7 col-md-12">
                                <div className="twm-hpage-6-getintouch">
                                    <div className="callus-bg-box">
                                        <div className="callus-bg-box-shadow" />
                                    </div>
                                    <div className="twm-hpage-6-getintouch-title">
                                        <div className="wt-title-small">Latest Blog</div>
                                        <h2 className="wt-title">
                                            Get your <span>Free</span>
                                            web consultation
                                        </h2>
                                    </div>
                                    <div className="twm-hpage-6-callus">
                                        <div className="callus-icon">
                                            <i className="flaticon-phone" />
                                        </div>
                                        <div className="callus-content">
                                            <div className="callus-number">555-281-5426</div>
                                            <div className="callus-email">Info@jobzilla.com</div>
                                        </div>
                                    </div>
                                </div>
                            </div> */}
                            <div className="col-lg-12 col-md-12" style={{ padding: '30px' }}>
                                <div className="twm-hpage-6-subscribe-wrap">
                                    <div className="col-lg-12 col-md-12 hpage-6-nw-form-corner-wrap">
                                        <div className="twm-hpage-6-subscribe">
                                            <div className="twm-sub-discription">
                                                {t("Ready to apply ?")}
                                            </div>
                                            <div
                                                className="hpage-6-nw-form"
                                                style={{
                                                    width: '300px',
                                                    height: '60px',
                                                    minWidth: '300px',
                                                    maxWidth: '300px',
                                                    minHeight: '60px',
                                                    maxHeight: '60px',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center'
                                                }}
                                            >
                                                <NavLink to={publicUser.pages.LOGIN}>
                                                    <button className="hpage-6-nw-form-btn" style={{ padding: '15px' }}>
                                                        {t("Start now")}
                                                        <i className="fa fa-arrow-right" style={{ marginLeft: '10px' }} />
                                                    </button>
                                                </NavLink>
                                            </div>
                                        </div>
                                        <div style={{ paddingBottom: '20px' }} className="hpage-6-nw-form-corner" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* SUBSCRIBE SECTION END */}
        </>
    )
}

export default HomePage;